import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import PageLayout from "./components/layout/PageLayout";
import { useLocation } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

function LayoutWrapper() {
  const location = useLocation();
  const { isLoading } = useAuth();
  const isAdmin = location.pathname.startsWith("/admin") || location.pathname.startsWith("/secure-admin-login");

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-primary-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (isAdmin) {
    return <AppRoutes />;
  }

  return (
    <PageLayout>
      <AppRoutes />
    </PageLayout>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <LayoutWrapper />
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;